export default __webpack_public_path__ + "static/media/tour_menu_item.6fd071ae.svg";